import { NavigationModeType, NavigationThemeType } from "./themes";

export const Application = {
  shop: "shop",
  pcom: "pcom",
  finder: "finder",
  icc: "icc",
  "connect-store": "connect-store",
  default: "default",
} as const;
export type ApplicationType = (typeof Application)[keyof typeof Application];

export interface ContextualIconProps {
  locale: string;
  app: ApplicationType;
  mode: NavigationModeType;
  theme: NavigationThemeType;
  isNavigationLoaded: boolean;
  isDesktop: boolean;
}

export interface ContextualIconPropsSSR {
  locale: string;
  app: ApplicationType;
  mode: NavigationModeType;
  theme: NavigationThemeType;
}

export interface ContextualIconResponse {
  leftIcons: HTMLElement | null;
  rightIcons: HTMLElement | null;
}

export enum DrawerStatusValues {
  startOpening = "startOpening",
  startClosing = "startClosing",
  finishOpening = "finishOpening",
  finishClosing = "finishClosing",
}

export const timeformat = 12;

export type DrawerStatusTypes =
  (typeof DrawerStatusValues)[keyof typeof DrawerStatusValues];
